export class EventReferenceField implements IEventReferenceField {
  /** Property name for reference type */
  refName!: string;
  /** Value for reference property. Usually a ID */
  refValue?: any | undefined;

  constructor(data?: IEventReferenceField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.refName = Data["refName"];
      this.refValue = Data["refValue"];
    }
  }

  static fromJS(data: any): EventReferenceField {
    data = typeof data === 'object' ? data : {};
    let result = new EventReferenceField();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["refName"] = this.refName;
    data["refValue"] = this.refValue;
    return data;
  }
}

export interface IEventReferenceField {
  /** Property name for reference type */
  refName: string;
  /** Value for reference property. Usually a ID */
  refValue?: any | undefined;
}